import { Form, Select } from 'antd';
import { useWhInfoFiltersStore } from 'shared/stores/use-wh-info-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { WarehouseFormSelect } from 'components/common/warehouse-form-select';
import { importExportOptions } from './constants';
import styles from './wh-info-filters.module.scss';

export const WhInfoFilters = () => {
  const [form] = Form.useForm();
  const { filters, setFilters } = useWhInfoFiltersStore();

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  return (
    <Form
      form={form}
      name='wh-info-filter'
      initialValues={{ ...filters, importExportType: 'all' }}
      layout='horizontal'
      className={styles.form}>
      <WarehouseFormSelect
        rootClassName={styles.formItem}
        label='Warehouse: '
        name='warehouseId'
        placeholder='Select warehouse'
        rules={[{ required: true }]}
        handleChange={handleSuccess}
        allowClear={false}
        withDeprecated={false}
        warehouseType='warehouse'
      />
      <Form.Item className={styles.formItem} label='Type: ' name='importExportType'>
        <Select options={importExportOptions} onChange={handleSuccess} />
      </Form.Item>
    </Form>
  );
};
